import apiService from '../../../services/api'

/**
 * Rush Drop API Service
 * Работа с эндпоинтом /api/fast-event/
 * (в коде и API модуль называется fast_event, в интерфейсе — Rush Drop)
 */
export const rushdropApi = {
  // Полные данные текущего эвента Rush Drop (softAuth, ответ кешируется сервером на 10 сек)
  getEvent: async (signal) => {
    const response = await apiService.makeRequest('/api/fast-event/', {
      method: 'GET',
      signal
    })
    return response
  },

  // Экран недельного розыгрыша (авторизация обязательна, общая часть кешируется на 60 сек).
  // Вне окна розыгрыша штатно приходит { enabled: false }
  getWeekly: async (signal) => {
    const response = await apiService.makeRequest('/api/fast-event/weekly/', {
      method: 'GET',
      signal
    })
    return response
  }
}

export default rushdropApi
